// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ee9a0d63","732":"36f9d66c","977":"a92d62cc"}[chunkId] + ".chunk.js";
};